export const validateMobileNumber = (mobileNumber: string): boolean => {
  return /^[89]\d{7}$/g.test(mobileNumber);
};

export const validateCode = (code: string): boolean => {
  return code.length === 6 && /^\d+$/.test(code);
};
